import { useContext } from 'react';
import { AppContext, AjaxContext } from 'commons-ui';

export interface AdPlacementConfig {
	enabled: boolean;
	isAdmobEnabledForAndroid: boolean;
	isAdmobEnabledForIOS: boolean;
	isAdmobEnabledForFreeApp: boolean;
	admobVersionConfig: {
		android: Array<{ minVersion: number; maxVersion: number }>;
		ios: Array<{ minVersion: number; maxVersion: number }>;
	};
	admobVersionConfigFreeApp: {
		android: Array<{ minVersion: number; maxVersion: number }>;
	};
	deviceConfig: {
		android: { enabled: boolean; minAppVersion: number };
		ios: { enabled: boolean; minAppVersion: number };
		'com.zupee.free': {
			android: { enabled: boolean; minAppVersion: number };
			ios: { enabled: boolean; minAppVersion: number };
		};
	};
	includeSegments: string[];
	excludeSegments: string[];
	placements: {
		[key: string]: {
			[adType: string]: {
				placementId: string;
				enabled: boolean;
				maxCount?: number;
				repeatAfter?: number;
				ios?: {
					placementId: string;
					placementIdAdmob?: string;
				};
				includeSegments: string[];
				excludeSegments: string[];
				deviceConfig?: any;
				'com.zupee.free'?: any;
			};
		};
	};
}

const ZOOKEEPER_ENDPOINTS = {
	GET_KEY: '/marketing/gameAdmin/zookeeper/getValueForKey',
	UPDATE_KEY: '/marketing/gameAdmin/zookeeper/updateKey'
};

export const useAdsConfigService = () => {
	const { getData, postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const getAdPlacementConfig = async (): Promise<AdPlacementConfig> => {
		const res = await getData({
			endpoint: ZOOKEEPER_ENDPOINTS.GET_KEY,
			queryParams: {
				serviceName: 'SUPERAPP.SERVICE',
				game: 'ludo',
				key: 'adPlacementConfig',
				appName
			}
		});
		// The API response has the config nested under 'value'
		return res.data?.value || res.data;
	};

	const updateAdPlacementConfig = async (updatedConfig: AdPlacementConfig, agent: string, description: string) => {
		const res = await postData({
			endpoint: ZOOKEEPER_ENDPOINTS.UPDATE_KEY,
			queryParams: {
				serviceName: 'SUPERAPP.SERVICE',
				game: 'ludo',
				key: 'adPlacementConfig',
				appName,
				approvalRequired: true
			},
			body: {
				data: updatedConfig,
				agent,
				desc: description
			}
		});
		return res;
	};

	return {
		getAdPlacementConfig,
		updateAdPlacementConfig
	};
};
